import { attachAuth } from '@if/mui'
import axios from 'axios'
import { simulatedDateRequestInterceptor } from './simulated-date-interceptor'

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
})

// Bearer + 401 re-auth. Runs before any token exists — it reads the token per request.
attachAuth(instance)

// Test tool: pins the API's calendar day to the tab's simulated date (ignored in prod).
instance.interceptors.request.use(simulatedDateRequestInterceptor)

export { instance as apiClient }
